import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { apiService } from '../../../utils/api';

export interface ModelDropdownItem {
  id: string;
  title: string;
  is_active: boolean;
}

export const useGetContractModels = () => {
  const contractId = useSelector((state: any) => state.contract.contract?.id ?? null);
  return useQuery<ModelDropdownItem[]>({
    queryKey: ['contract-models', contractId],
    queryFn: async () => {
      const { data } = await apiService.get(
        `/api/v1/model/dropdown/?contract=${contractId}&pagination=false`
      );
      return data;
    },
    enabled: !!contractId,
    refetchOnWindowFocus: false,
  });
};
